/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Scroller from "vux/src/components/scroller/index.vue"; // this line is trasformed by vux-loader
import LoadMore from "vux/src/components/load-more/index.vue"; // this line is trasformed by vux-loader
import CheckIcon from "vux/src/components/check-icon/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import UserLogo from '@/components/UserLogo';
import SearchBar from '@/components/SearchBar';
export default {
  components: {
    Scroller: Scroller,
    LoadMore: LoadMore,
    CheckIcon: CheckIcon,
    XButton: XButton,
    UserLogo: UserLogo,
    SearchBar: SearchBar
  },
  props: {
    height: {
      type: Number,
      required: true
    },
    // 是否是两行列表
    size: {
      type: String,
      default: 'normal'
    },
    // 是否显示图片
    showImage: {
      type: Boolean,
      default: false
    },
    circleImage: {
      type: Boolean,
      default: false
    },
    isPx: {
      type: Boolean,
      default: false
    },
    // 是否开启多选框
    check: {
      type: Boolean,
      default: false
    },
    // 多选数量上限 默认为-1不限制
    maxCheck: {
      type: Number,
      default: -1
    },
    total: {
      type: Number
    }
  },
  data: function data() {
    return {
      // 上拉加载配置
      pullupDefaultConfig: {
        content: i18n.tc("565"),
        pullUpHeight: 150,
        height: 40,
        autoRefresh: false,
        downContent: i18n.tc("566"),
        upContent: i18n.tc("565"),
        loadingContent: i18n.tc("206"),
        clsPrefix: 'smy__plugin-pullup-'
      },
      // 下拉刷新配置
      pulldownDefaultConfig: {
        downContent: i18n.tc("394"),
        upContent: i18n.tc("567"),
        loadingContent: i18n.tc("392"),
        clsPrefix: 'smy__plugin-pulldown-'
      },
      noMoreShow: false,
      // 没有更多结果 显示
      noResult: false,
      // 没有数据 显示
      checkList: [],
      // 选中的列表
      checkListImg: [],
      // 选中的列表图片信息
      slotsDefaultLength: 0,
      // item数量
      pulldownLoading: false,
      pullupLoading: false
    };
  },
  computed: {
    // rem高度参数转为px
    heightToPx: function heightToPx() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      var height = this.height;
      if (!this.isPx) height = fontSize * height;
      // 如果开启了多选 需要减去上下距离
      if (this.check) {
        var top = 4.32 * fontSize;
        var bottom = 4 * fontSize;
        height = height - top - bottom;
      }
      return height;
    },
    isCheckAll: function isCheckAll() {
      return this.slotsDefaultLength === this.checkList.length;
    }
  },
  watch: {
    // 无结果显示
    total: function total(val) {
      if (val || val === 0) {
        if (val === 0) {
          if (!this.noResult) this.noResult = true;
        }
        if (val > 0) {
          if (this.noResult) this.noResult = false;
        }
      }
    },
    checkList: function checkList(val, oldVal) {
      var _this = this;
      this.$nextTick(function () {
        if (_this.maxCheck > 0 && _this.checkList.length > _this.maxCheck) {
          _this.$vux.toast.text("\u6700\u591A\u53EF\u9009".concat(_this.maxCheck, i18n.tc("479")));
          _this.checkList = oldVal.splice(0, _this.maxCheck);
        }
        if (_this.$slots.default) {
          var slotCheckList = _this.$slots.default.filter(function (item) {
            return val.indexOf(item.componentInstance.value) !== -1;
          });
          var checkListImg = slotCheckList.map(function (item) {
            return {
              imgUrl: item.componentInstance.imgUrl,
              name: item.componentInstance.name
            };
          });
          _this.checkListImg = checkListImg;
        } else {
          _this.checkListImg = [];
        }
        _this.$emit('on-check-change', _this.checkList.slice().sort(function (a, b) {
          return a - b;
        }));
      });
    }
  },
  methods: {
    // 全选 开关
    isCheckAllChange: function isCheckAllChange() {
      if (this.isCheckAll) {
        this.checkList = [];
      } else {
        var _iterator = _createForOfIteratorHelper(this.$slots.default),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.componentInstance.isCheck = true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    // 下拉刷新
    onPulldown: function onPulldown() {
      this.pulldownLoading = true;
      this.$emit('on-pulldown-loading');
      this.$refs.scrollerBottom.disablePullup();
    },
    // 下拉刷新完成
    donePulldown: function donePulldown() {
      var _this2 = this;
      setTimeout(function () {
        _this2.pulldownLoading = false;
      }, 1000);
      this.$refs.scrollerBottom.donePulldown();
      if (this.check) {
        // 刷新后清空选中
        this.checkList = [];
        // 获取item数量
        this.$nextTick(function () {
          _this2.slotsDefaultLength = _this2.$slots.default ? _this2.$slots.default.length : 0;
        });
      }
      this.$refs.scrollerBottom.enablePullup();
    },
    // 上拉加载
    onPullup: function onPullup() {
      this.pullupLoading = true;
      this.$emit('on-pullup-loading');
    },
    // 上拉加载完成
    donePullup: function donePullup() {
      var _this3 = this;
      this.$refs.scrollerBottom.donePullup();
      setTimeout(function () {
        _this3.pullupLoading = false;
      }, 1000);
      if (this.check) {
        // 获取item数量
        this.$nextTick(function () {
          _this3.slotsDefaultLength = _this3.$slots.default ? _this3.$slots.default.length : 0;
        });
      }
    },
    // 开启上拉加载
    enablePullup: function enablePullup() {
      this.$refs.scrollerBottom.enablePullup();
      this.noMoreShow = false;
    },
    // 禁用上拉加载
    disablePullup: function disablePullup() {
      this.$refs.scrollerBottom.disablePullup();
      this.noMoreShow = true;
    },
    // 初始化状态
    initLoading: function initLoading() {
      this.noResult = false;
      this.noMoreShow = false;
    },
    // 滚动到顶部
    scrollToTop: function scrollToTop() {
      this.$refs.scrollerBottom.reset({
        top: 0
      });
    }
  },
  created: function created() {
    if (this.total || this.total === 0) {
      if (this.total === 0) {
        if (!this.noResult) this.noResult = true;
      }
      if (this.total > 0) {
        if (this.noResult) this.noResult = false;
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    this.$nextTick(function () {
      _this4.$refs.scrollerBottom.reset();
      if (_this4.check) {
        _this4.slotsDefaultLength = _this4.$slots.default ? _this4.$slots.default.length : 0;
      }
    });
  }
};